import React, {useState, useEffect} from 'react'
import { Heading, Spinner } from '../common/atoms'
import { Row, Col, Card } from 'antd';
import {successOrFailureToaster} from '../common/atoms/messages';
import { TestMailModal, PopUpModals, LaunchMailerModal, FailModal } from '../modals';
import {  useHistory } from 'react-router-dom';
import { companyMailerApi, employeeDataApi } from '../../services';
import { handleAppError } from '../handlers';
import { EMAIL_REGEX, DAYS, MONTHS, LAUNCH_MAILER_RELEASE_DATE} from '../../constants/companyMailer';
import { emailer, review_mailer, static_confetti, 
        confetti, close_icon, close_copy, mile_stone  } from '../../assets/images';
import moment from 'moment';

const MailLandingPage = (props) => {
    const [pageloading, setPageLoading] = useState(true);
    let suState = {mail_count: 1, delivery: {}, engagement: {}, sent: false, type: ''}
    const [stats, setStats] = useState({teaser: suState, pre_launch: suState, launch: suState});
    const [test, setTest] = useState({mail: '', testMail: false, data: {}});
    let subState = {id: 0, subject: '',sender: '', preview: '', updated_at: '', content: '', sent_at: 'rt'}
    const [state, setState] = useState({
      teaser: subState,
      pre_launch: subState,
      launch: subState
    })
    const [sendModal, setSendModal] = useState({send: false, type: '', launch: false, launchSent: false, count: 0, activate: 0, disable: false})
    const history = useHistory();

    useEffect(() => {
      if(sessionStorage.getItem('launch_date') < LAUNCH_MAILER_RELEASE_DATE){
        history.push('/overview')
      }
      const options = {}
      companyMailerApi.mail_steup(
          options,
          (res) =>{
              let data = res.data.mailer
              setState((prevValues) => {
                return {...prevValues, ...data}
              }) 
          },
          (err) => handleAppError(err)
      );
      fetchInsigths();
      setPageLoading(false)
  }, [])

  const fetchInsigths = () => {
    let active_emp = 0;
    let launch_date = sessionStorage.getItem('launch_date')
    employeeDataApi.fetch_manage_employee_metric_card({} , 
      (res) =>{
        let data = res.data 
        active_emp = data.active_users_session_count;
      },
      (error) => handleAppError(error)
    )
    const options = {}
    companyMailerApi.mailer_insights(
      options,
      (res) => {
        if(res.data.stats){
          setStats(res.data.stats);
          setSendModal((prev) => {
            return{...prev,...{count: res.data.employee_count, activate: active_emp}}
          })
          let data = res.data.stats;
          let popup = sessionStorage.getItem('popUp')
          if((moment(new Date()).format("YYYY-MM-DD") >= launch_date && data.launch.sent === false && (popup !== 'stop'))) {
            let subState = { launch: !sendModal.launch, type: 'official launch'}
            setSendModal((prev) => {
              return{...prev,...subState}
            });
          }
        }
      },
      (err) => {
        handleAppError(err)
      }
    )
  }
  
    const sendTest = () => {
        if(handleValidation(test.mail)){
          test.mail.split(',').map((mail) => {
          const options = { id: test.data.id, data: {...test.data, email: mail.trim()} }

          companyMailerApi.test_mail(
            options,
            (res) => {
              if(res.data.message === "success"){
                let message = `Test email sent successfully to: ${test.mail.replace(',',', ')}`
                successOrFailureToaster({ message, type: 'success'})
                setTest((prev) => { return {...prev,...{testMail: false}}})
                history.push('/mailer')
              }else{
                successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
              }
            },
            (err) => handleAppError(err)
          )
        })
        }else{
          alert('Not a valid email address.')
        }
    }

    const handleValidation = (email) => {
      let errors = {};
      let formIsValid = true
      email.split(',').map((mail) => {
      if (!mail.trim().match(EMAIL_REGEX)){
        errors["email"] = "Not a valid email"
        formIsValid = false
      }
      })
      return formIsValid
    }

    const testMailFunc = (e) => {
      let data = test.testMail;
      let subState = {testMail: !data}
      setTest((prevValues) => {
        return{...prevValues,...subState}
      });
    }
  
    const mailStep = (e) => {
        let data = val(e);
        history.push({
            pathname: '/mail-setup',
            state: { title: e.target.name,
                     id: data.id,
                    count: sendModal.count}
        })
    }

    const edit_preview = (e) => {
      let data = val(e);
      history.push({
        pathname: '/mail-config',
        state: {id: data.id,
                show: true}
      })
    }

    const sentTestMail = (e) => {
      let data = val(e);
      let subState = {testMail: true, data: data}
      setTest((prev) => {
        return{...prev,...subState}
      })
    }

    const sendMailNowOrLater = (e) => {
      e = e === 'official launch' ? e : e.target.name;
      let subState = {}
      if(e === 'official launch'){
        subState = {launch: !sendModal.launch, type: e || ''}
      }else{
        subState = {send: !sendModal.send, type: e || ''}
      }
      setSendModal((prev) => {
        return{...prev,...subState}
      });
    }

    const closeSendModal = () => {
        let subState = {launch: false, send: false}
        setSendModal((prev) => {
          return{...prev,...subState}
        })
        sessionStorage.setItem('popUp','stop');
    }

    const launchMailSent = () => {
      let subState = {launch: false, launchSent: true}
      setSendModal((prev) => {
        return{...prev,...subState}
      })
      mail_sender()
      sessionStorage.setItem('is_active', 'active');
    }

    const launchDone = () => {
      let subState = {launchSent: !sendModal.launchSent}
      setSendModal((prev) => {return{...prev,...subState}})
      window.location.reload()
    }
    
    const val = (e) => {
      let event = e.target !== undefined ? e.target.name : e
        let data = {}
        if (event === 'teaser 1'){
            data = state.teaser;
        }else if(event === 'teaser 2'){
            data = state.pre_launch;
        }else{
            data = state.launch;
        }
        return(data);
    }

    const mail_sender = () => {
      let type = sendModal.type;
      setPageLoading(true);
      let data = val(type)
      const options = {id: data.id};
        companyMailerApi.mailer_sender(
          options,
          (res) => {
            if(res.data.message === "success"){
              setSendModal((prev) => {return {...prev,send: false}})
              setPageLoading(false);
              if(type !== 'official launch'){
                let message = 'Congratulations! Your campaign was successfully created. Your campaign is queued to be sent.'
                successOrFailureToaster({ message, type: 'success'})
                window.location.reload()
              }
            }else{
              successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
              setSendModal((prev) => {return {...prev, disable: true, send: false}})
            }
          },
          (err) => {
            if(err?.response?.data?.message === 'employee count is less than required'){
              let subState = {launch: false, launchSent: false, disable: true, send: false}
              setSendModal((prev) => {return {...prev, ...subState }})
            }else{
              let subState = {launch: false, launchSent: false, disable: false, send: false}
              setSendModal((prev) => {return {...prev, ...subState }})
              handleAppError(err)
            }
          }
        )
      fetchInsigths()
      setPageLoading(false);
    }

    const dateFormat = (val) => {
      let DATE = new Date(val)
      let day = DATE.getDay();
      let date = DATE.getDate();
      let mon = DATE.getMonth()
      let year = DATE.getFullYear();
      let hrs = DATE.getHours()
      let min = DATE.getMinutes()
      let finalDate = `${DAYS[day] || ''}, ${date || ''} ${MONTHS[mon] || ''} ${year || ''} at ${hrs.toString().length > 1 ? hrs : '0'+hrs}:${min.toString().length > 1 ? min : '0'+min}`

      if(val){
        return finalDate
      }else{
        return ''
      }
    }
    
    const insights = (data) => {
      if (data){
        let count = data.mail_count
        let sent = 0;
        let delivered_stats = data.delivery?.delivered + data.delivery?.processed
        if(data.delivery?.delivered !== undefined) {sent+= data.delivery?.delivered}
        if(data.delivery?.processed !== undefined) {sent+= data.delivery?.processed}
        if(data.delivery?.bounce !== undefined) {sent+= data.delivery?.bounce}
        if(data.delivery?.deferred !== undefined) {sent+= data.delivery?.deferred}
        return(
          <div className='font-semibold float-right flex flex-row'>
            { data.delivery.delivered &&
              <div className='px-5 mx-4 text-center'>
              <div className='uppercase text-xs tracking-widest' style={{color: '#7C8CAB'}}>SENT</div>
              <div className='text-xl' style={{color: '#0D1A35'}}>{Math.trunc(sent/count*100)}%</div>
              <div className='font-normal text-xs' style={{color: '#7C8CAB'}}>{sent} Emails</div>
            </div>}
            { data.delivery.delivered &&
            <div className='px-4 mx-4 text-center'>
              <div className='text-xs uppercase tracking-widest' style={{color: '#7C8CAB'}}>Delivered</div>
              <div className='text-xl' style={{color: '#0D1A35'}}>{Math.trunc(delivered_stats/count*100)}%</div>
              <div className='font-normal text-xs' style={{color: '#7C8CAB'}}>{delivered_stats} Emails</div>
            </div>}
            { data.engagement.open &&
            <div className='px-4 mx-4 text-center'>
              <div className='text-xs uppercase tracking-widest' style={{color: '#7C8CAB'}}>Opened Rate</div>
              <div className='text-xl' style={{color: '#0D1A35'}}>{Math.trunc(data.engagement?.open/count*100)}%</div>
              <div className='font-normal text-xs' style={{color: '#7C8CAB'}}>{data.engagement?.open} Opened</div>
            </div>}
           { stats.launch?.sent && sendModal.activate > 0 && (data.type === "launch") &&
           <div className='px-5 mx-4 text-center'>
              <div className='text-xs uppercase tracking-widest' style={{color: '#7C8CAB'}}>Action</div>
              <div className='text-xl' style={{color: '#0D1A35'}}>{Math.trunc(sendModal.activate/count*100)}%</div>
              <div className='font-normal text-xs' style={{color: '#7C8CAB'}}>{sendModal.activate} Activated</div>
            </div>}
          </div>
        )
    }
    }

    const closeModal = () => {
      setSendModal((prev) => {return {...prev, disable: false}})
    }

    const background = (val = false) => {return(val ? '#DBFBE9' : '#E5EEFF')}
    const textColor = (val = false) => {return(val ? '#00A04F' : '#4D6189')}

    return(
        <Spinner visible={pageloading}>
          { test.testMail && 
            <TestMailModal 
              title='Send a Test Email' 
              description='Send a test to' 
              onClose={testMailFunc} 
              onSave={sendTest} 
              inputVal={(val) => {setTest((prev) => {return{...prev,...{mail: val}}})}} 
            />
          }
          { sendModal.send &&
            <PopUpModals 
              title={['Review ',sendModal.type]}
              description={["You are about to send the ",sendModal.type === 'teaser 1' ? <strong>first</strong> : <strong>second</strong>, <strong> teaser mail. </strong>,"It will help your employees know that something ", <strong>new</strong>, " and ",<strong>big</strong>," is coming"]}
              onCancel='Send it later'
              onPass='Send now'
              icon={review_mailer}
              onClose={closeSendModal}
              onSave={mail_sender}
            />
          }
           { sendModal.launch &&
            <LaunchMailerModal 
              title='Congratulations!'
              description={"Your workplace is going to take a big step toward becoming a healthier place in no time"}
              onPass='Launch now'
              launch={true}
              onClose={closeSendModal}
              onSave={launchMailSent}
              confetti={static_confetti}
              close_icon={close_copy}
            />
          }
          { (sendModal.launchSent) &&
            <LaunchMailerModal 
              title='Congratulations!'
              description={["On taking steps to keep your employees healthy. ",
              <span className='text-blue-600 font-bold'><br/>{sendModal.count} employees</span>,
              " in your company now have access to",<strong> health<br/> benefits via ekincare</strong>]}
              icon={mile_stone}
              onClose={launchDone}
              onSave={launchDone}
              confetti={confetti}
              close_icon={close_icon}
            />
          }
          <FailModal
            visible={sendModal.disable}
            title='Missing employee list'
            description='Mails cannot be sent because employees are not added.'
            btntext='Okay'
            close={closeModal}
            btnhandler={closeModal}
            missing={true}
          />
            <div>
                <Heading mainHeading="Pre Launch" classes='mt-2'/>
                <p className='text-sm font-normal'>Plan the launch experience for your employees' health benefits</p>
                <Card style={{ minHeight: 230, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
                    <Row className='font-semibold text-lg'>Teaser 1
                        <span style={{background: background(stats.teaser?.sent), color: textColor(stats.teaser?.sent)}} className='rounded-xl px-2.5 py-1.5 ml-2 font-semibold text-xs'>
                          {stats.teaser?.sent ? 'Sent' : 'Draft'}
                        </span>
                    </Row>
                    <Row style={{ fontWeight: 400, width: '70%', marginTop: 7}}>
                        Teaser is a short e-mail that creates a buzz among employees about the new benefit they would be receiving.
                    </Row>
                    { !stats.teaser?.sent &&
                      <div className='absolute top-6 right-6'>
                    <button
                        name='teaser 1'
                        type='submit'
                        onClick={mailStep}
                        className='inline-flex right-8 items-center mx-4 px-4 py-3 text-base font-semibold rounded-md text-blue-700 hover:bg-blue-50 transition'
                    >
                        Edit teaser
                    </button>
                    <button name='teaser 1' type='submit' 
                      className='inline-flex right-8 items-center px-4 py-2 border-2 border-gray-200 text-base font-semibold rounded-md hover:bg-blue-50 transition text-blue-700 focus:outline-none' 
                      onClick={sendMailNowOrLater}>
                        Send now
                    </button>
                    </div>}
                    <Row style={{background: '#F5F8FF80'}} className='my-4 px-3 py-4 rounded border-2'>
                        <div className='float-left flex flex-row'>
                          <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                          <div className='mx-2'>
                            <div className='font-semibold text-base' style={{color: '#0D1A35'}}>Subject : {state.teaser.subject}</div>
                            <div className=''><strong className='text-slate-800'>{stats.teaser?.sent ? 'Sent' : 'Draft'}</strong> on {stats.teaser?.sent ? dateFormat(state.teaser.sent_at) : dateFormat(state.teaser.updated_at)}</div>
                            { !stats.teaser?.sent &&
                              <div className='flex items-center'>
                                <button name='teaser 1' onClick={sentTestMail} style={{color: '#0951E1'}} className='font-semibold'>Send Test Mail</button>
                                <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D9D9D9'}}></div>
                                <button name='teaser 1' onClick={edit_preview} style={{color: '#0951E1'}} className='font-semibold'>Preview</button>
                              </div>}
                          </div>
                        </div>
                        {stats.teaser?.sent && insights(stats.teaser)}
                    </Row>
                </Card>
                <Card style={{ minHeight: 210, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
                    <Row className='font-semibold text-lg'>Teaser 2
                        { !stats.pre_launch?.sent && <span style={{background: '#FEFBED', color: '#FFB500'}} className='rounded-xl px-2.5 py-1.5 ml-2 font-semibold text-xs'>Optional</span>}
                        <span style={{background: background(stats.pre_launch?.sent), color: textColor(stats.pre_launch?.sent)}} className='rounded-xl px-2.5 py-1.5 ml-2 font-semibold text-xs'>
                          {stats.pre_launch?.sent ? 'Sent' : 'Draft'}
                        </span>
                    </Row>
                    <Row style={{fontWeight: 400, width: '70%', marginTop: 7}}>
                        To keep the momentum before launch of the product
                    </Row>
                    { !stats.pre_launch?.sent &&
                      <div className='absolute top-6 right-6'>
                    <button
                        name='teaser 2'
                        type='submit'
                        onClick={mailStep}
                        className='inline-flex right-8 items-center mx-4 px-4 py-3 text-base font-semibold rounded-md text-blue-700 hover:bg-blue-50 transition'
                    >
                        Edit teaser
                    </button>
                    <button name='teaser 2' type='submit' 
                      className='inline-flex right-8 items-center px-4 py-2 border-2 border-gray-200 text-base font-semibold rounded-md hover:bg-blue-50 transition text-blue-700 focus:outline-none' 
                      onClick={sendMailNowOrLater}>
                        Send now
                    </button>
                    </div>}
                    <Row style={{background: '#F5F8FF80'}} className='my-4 px-3 py-3 rounded border-2'>
                        <div className='flex flex-row float-left'>
                          <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                          <div className='mx-2'>
                            <div className='font-semibold text-base' style={{color: '#0D1A35'}}>Subject : {state.pre_launch.subject}</div>
                            <div className=''><strong className='text-slate-800'>{stats.pre_launch?.sent ? 'Sent' : 'Draft'}</strong> on {stats.pre_launch?.sent ? dateFormat(state.pre_launch.sent_at) : dateFormat(state.pre_launch.updated_at)}</div>
                            { !stats.pre_launch?.sent &&
                              <div className='flex items-center'>
                              <button name='teaser 2' onClick={sentTestMail} style={{color: '#0951E1'}} className='font-semibold'>Send Test Mail</button>
                              <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D9D9D9'}}></div>
                              <button name='teaser 2' onClick={edit_preview} style={{color: '#0951E1'}} className='font-semibold'>Preview</button>
                              </div>}
                          </div>
                        </div>
                        {stats.pre_launch?.sent && insights(stats.pre_launch)}
                    </Row>
                </Card>
                <Card style={{ minHeight: 150, marginTop: 20 }} loading={pageloading} className='overview-card relative'>
                    <Row className='font-semibold text-lg'>Official Launch 
                        <span style={{background: background(stats.launch?.sent), color: textColor(stats.launch?.sent)}} className='rounded-xl px-2.5 py-1.5 ml-2 font-semibold text-xs'>
                          {stats.launch?.sent ? 'Sent' : 'Draft'}
                        </span>
                    </Row>
                    <Row style={{fontWeight: 400, width: '70%', marginTop: 7}}>
                        On the day of the official launch to keep informed all the employees about the services, benefits and how to avail of them an official communication gets sent to them. 
                    </Row>
                    { !stats.launch?.sent &&
                      <div className='absolute top-6 right-6'>
                        <button
                            name='official launch'
                            type='submit'
                            onClick={mailStep}
                            className='inline-flex right-8 items-center mx-4 px-4 py-3 text-base font-semibold rounded-md text-blue-700 hover:bg-blue-50 transition'
                        >
                        Edit emailer
                    </button>
                    <button name='official launch' type='submit' 
                      className='inline-flex right-8 items-center px-4 py-2 border-2 border-gray-200 text-base font-semibold hover:bg-blue-50 transition rounded-md text-blue-700 focus:outline-none' 
                      onClick={sendMailNowOrLater}>
                        Send now
                    </button>
                    </div>}
                    <Row style={{background: '#F5F8FF80'}} className='my-4 px-3 py-3 rounded border-2'>
                        <div className='flex flex-row float-left'>
                          <img src={emailer} alt='#' style={{height: 46, width: 48}}/>
                          <div className='mx-2'>
                            <div className='font-semibold text-base' style={{color: '#0D1A35'}}>Subject : {state.launch.subject}</div>
                            <div className=''><strong className='text-slate-800'>{stats.launch?.sent ? 'Sent' : 'Draft'}</strong> on { stats.launch?.sent ? dateFormat(state.launch.sent_at) : dateFormat(state.launch.updated_at)}</div>
                            { !stats.launch?.sent &&
                              <div className='flex items-center'>
                                <button name='launch' onClick={sentTestMail} style={{color: '#0951E1'}} className='font-semibold'>Send Test Mail</button>
                                <div className="bg-zinc-300 rounded mx-2 w-1 h-1 font-semibold" style={{background: '#D9D9D9'}}></div>
                                <button name='launch' onClick={edit_preview} style={{color: '#0951E1'}} className='font-semibold'>Preview</button>
                              </div>}
                          </div>
                        </div>
                        {stats.launch?.sent && insights(stats.launch)}
                    </Row>
                </Card>
            </div>
        </Spinner>
    )

}

export default MailLandingPage;